import { BehaviorSubject, filter, map, Subject, takeUntil } from 'rxjs';

import { AsyncPipe } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AlertService } from '../../../../core/services/alert.service';
import { ConfirmationService } from '../../../../core/services/confirmation.service';
import { ShippingStatusEnum } from '../../enums/shipping-status.enum';
import { IShippingFailure } from '../../interfaces/shipping-failure.interface';
import { IShippingState } from '../../interfaces/shipping-state.interface';
import { ShippingService } from '../../services/shipping.service';
import { ShippingConcludedComponent } from '../shipping-concluded/shipping-concluded.component';
import { ShippingConfirmationComponent } from '../shipping-confirmation/shipping-confirmation.component';
import { ShippingDetailsComponent } from '../shipping-details/shipping-details.component';
import { ShippingFailedComponent } from '../shipping-failed/shipping-failed.component';
import { ShippingLoaderComponent } from '../shipping-loader/shipping-loader.component';

@Component({
  selector: 'peca-shipping',
  templateUrl: './shipping.component.html',
  styleUrl: './shipping.component.scss',
  imports: [AsyncPipe, ShippingLoaderComponent, ShippingFailedComponent, ShippingDetailsComponent, ShippingConfirmationComponent, ShippingConcludedComponent],
})
export class ShippingComponent implements OnInit, OnDestroy {
  alert = inject(AlertService);
  confirmationService = inject(ConfirmationService);
  shippingService = inject(ShippingService);
  router = inject(Router);
  activatedRoute = inject(ActivatedRoute);
  shippingState$ = new BehaviorSubject<IShippingState>({ loading: true });
  destroyRef$ = new Subject<void>();
  route: any[] = [];
  failure: IShippingFailure = { title: '', description: '' };
  shippingStatusEnum = ShippingStatusEnum;

  get shippingReferenceSnapshot() {
    return this.activatedRoute.snapshot.paramMap.get('shippingReference') as string;
  }

  get hasInitialized() {
    return this.shippingState$.value.data?.status !== ShippingStatusEnum.SEARCHING_CARRIER;
  }

  ngOnInit() {
    this.activatedRoute.params
      .pipe(
        takeUntil(this.destroyRef$),
        map(({ shippingReference }) => shippingReference),
        filter((shippingReference) => !!shippingReference)
      )
      .subscribe((shippingReference) => this.fetchShipping(shippingReference));
  }

  ngOnDestroy(): void {
    this.destroyRef$.next();
    this.destroyRef$.unsubscribe();
  }

  fetchShipping(shippingId: string) {
    this.shippingState$.next({ loading: true });
    this.shippingService.fetchShipping(shippingId).subscribe({
      next: (data) => this.shippingState$.next({ data }),
      error: (error) => this.onFetchShippingFailure(error),
    });
  }

  onFetchShippingFailure(error: Error) {
    this.failure = {
      title: 'Falha ao obter entrega',
      description: 'Não foi possível obter os detalhes da sua entrega. Por favor, entre em contato com o suporte Peça Aí.',
    };

    this.shippingState$.next({ failed: true });
  }

  onReloadShipping() {
    const shippingReference = this.shippingReferenceSnapshot;
    this.fetchShipping(shippingReference);
  }

  onRetryFetch() {
    this.onReloadShipping();
  }
}
